var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row"},[_c('YearSelector',{on:{"select":_vm.load}}),_c('v-spacer'),_c('Create',{staticClass:"mr-3",on:{"created":_vm.load}}),_c('Announce')],1),_c('Table',{staticClass:"my-5"}),_c('Detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }